export default __webpack_public_path__ + "static/hero-2-945801344a4e81f15a234a39a575c484.webp";